import { useEffect, useState } from "react";
import AuthenticatedUserApp from "./Authenticated";
import UnAuthenticated from "./UnAuthenticated";
import { useSelector } from "react-redux";
import { type RootReducer } from "lib/redux/reducers";

const Pages = () => {
  const login = useSelector<RootReducer, any>((state) => state.auth.user);

  const [isLoggedIn, setisLoggedIn] = useState(login.success);
  useEffect(() => {
    setisLoggedIn(login.success);
  }, [login]);

  if (isLoggedIn) {
    return <AuthenticatedUserApp />;
  }
  return <UnAuthenticated />;
};

export default Pages;
